module.exports = __webpack_public_path__ + "img/store.b33798ce.svg";